import { render } from "./SidebarItem.vue?vue&type=template&id=1ed9ee52&scoped=true"
import script from "./SidebarItem.vue?vue&type=script&lang=ts"
export * from "./SidebarItem.vue?vue&type=script&lang=ts"

import "./SidebarItem.vue?vue&type=style&index=0&id=1ed9ee52&lang=scss&scoped=true"
import "./SidebarItem.vue?vue&type=style&index=1&id=1ed9ee52&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1ed9ee52"

export default script